module.exports = __webpack_public_path__ + "img/bch.0c7af8a8.svg";